var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.956,
    height: 19.954,
    viewBox: "0 0 19.956 19.954",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Light-Outline_Image-2",
    "data-name": "Iconly/Light-Outline/Image-2",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Image-2",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M14.3,0a5.516,5.516,0,0,1,4.01,1.554,6.057,6.057,0,0,1,1.641,4.351l0,7a.778.778,0,0,1,0,.081l0,1.068c0,3.531-2.273,5.9-5.656,5.9H5.651C2.271,19.954,0,17.581,0,14.05V5.9C0,2.373,2.271,0,5.651,0Zm.277,10.832c-.588,0-1.278.973-1.889,1.832-.838,1.18-1.7,2.4-3.011,2.4a6.23,6.23,0,0,1-2.4-.641c-1.134-.478-1.648-.631-2.151-.217a13.776,13.776,0,0,0-2.459,3.084,4.041,4.041,0,0,0,2.987,1.163H14.3c2.525,0,4.156-1.728,4.156-4.4v-.8l-.023-.024C17.555,12.325,16.043,10.832,14.579,10.832ZM14.3,1.5H5.651C3.13,1.5,1.5,3.229,1.5,5.9V14.05a5.394,5.394,0,0,0,.294,1.816A13.5,13.5,0,0,1,4.17,13.049c1.252-1.03,2.6-.464,3.686-.007a4.981,4.981,0,0,0,1.823.523c.532,0,1.2-.94,1.789-1.769.819-1.156,1.749-2.464,3.111-2.464a6.172,6.172,0,0,1,3.875,1.83V5.9a4.518,4.518,0,0,0-1.2-3.29A4.052,4.052,0,0,0,14.3,1.5ZM6.857,4.189a2.6,2.6,0,0,1,2.6,2.6h0a2.6,2.6,0,1,1-2.6-2.6Zm0,1.5a1.1,1.1,0,1,0,1.1,1.1A1.1,1.1,0,0,0,6.856,5.689Z",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.c9ecec49.svg";
export { ForwardRef as ReactComponent };